import React from 'react';
import { 
  ShieldCheckIcon, 
  UserGroupIcon, 
  GlobeAltIcon, 
  CurrencyDollarIcon,
  HeartIcon,
  TrophyIcon
} from '@heroicons/react/24/outline';

const WhyChooseUs = () => {
  const features = [
    {
      id: 1,
      title: 'Expert Local Guides',
      description: 'Our guides are certified professionals with deep knowledge of wildlife, habitats, and conservation efforts.',
      icon: UserGroupIcon,
    },
    {
      id: 2,
      title: 'Safety First Approach',
      description: 'Your safety is our priority with comprehensive safety protocols and emergency procedures.',
      icon: ShieldCheckIcon,
    },
    {
      id: 3,
      title: 'Sustainable Tourism',
      description: 'We are committed to eco-friendly practices and supporting local communities.',
      icon: GlobeAltIcon,
    },
    {
      id: 4,
      title: 'Competitive Pricing',
      description: 'Enjoy premium experiences at reasonable prices with no hidden costs.',
      icon: CurrencyDollarIcon,
    },
    {
      id: 5,
      title: 'Personalized Experience',
      description: 'Customized itineraries tailored to your preferences and travel style.',
      icon: HeartIcon,
    },
    {
      id: 6,
      title: 'Award-Winning Service',
      description: 'Recognized for excellence in customer satisfaction and tour quality.',
      icon: TrophyIcon,
    }
  ];

  return (
    <section className="section bg-white why-choose-section">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 company-name">Why Choose Teem Wildlife Wonders</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            As a premier tours and travel agency based in Nairobi, Kenya, we specialize in creating customized travel itineraries 
            that showcase the diverse beauty, rich culture, and vibrant wildlife of Kenya. Here's what sets us apart from other tour operators.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div 
              key={feature.id} 
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border-t-4 border-primary"
            >
              <div className="flex items-start">
                <div className="flex-shrink-0 mr-4">
                  <div className="bg-primary-light p-3 rounded-full">
                    {React.createElement(feature.icon, { className: "h-6 w-6 text-primary" })}
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-bold mb-2">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
